import { Button, ButtonProps } from 'antd';
import { useIntl } from 'react-intl';

interface Props extends ButtonProps {
  intl: string;
}

export default function PurchasesButtonsRules({ intl, ...props }: Props) {
  const innerText = useIntl().formatMessage({ id: intl });

  return (
    <Button block {...props}>
      {innerText}
    </Button>
  );
}
